import { render, staticRenderFns } from "./DashboardEventsCalendar.vue?vue&type=template&id=663b480a&"
import script from "./DashboardEventsCalendar.vue?vue&type=script&lang=js&"
export * from "./DashboardEventsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEventsCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports